import UserDeleteUserData from "../../../modules/user/common/delete/common/types/user-delete-user-data";
import UserCargoOfficerListRequest from "../../api/raily/user/cargo-officer/list/user-cargo-officer-list.request";
import UserDealerListRequest from "../../api/raily/user/dealer/list/user-dealer-list.request";
import {
  UserDeleteNotAcceptableResponse,
  UserDeleteNotAcceptableResponseErrorType,
} from "../../api/raily/user/delete/user-delete.response";
import UserDispatcherEditFormRequest from "../../api/raily/user/dispatcher/edit-form/user-dispatcher-edit-form.request";
import UserDispatcherListRequest from "../../api/raily/user/dispatcher/list/user-dispatcher-list.request";
import UserDispatcherUpdateRequest from "../../api/raily/user/dispatcher/update/user-dispatcher-update.request";
import UserDriverDownloadRequest from "../../api/raily/user/driver/download/user-driver-download.request";
import UserDriverEditFormRequest from "../../api/raily/user/driver/edit-form/user-driver-edit-form.request";
import User from "../../api/raily/user/driver/edit/user-driver-edit.request";
import UserDriverListRequest from "../../api/raily/user/driver/list/user-driver-list.request";
import UserOperatorListRequest from "../../api/raily/user/operator/list/user-operator-list.request";
import UserPassengerListRequest from "../../api/raily/user/passenger/list/user-passenger-list.request";
import UserRailyOfficerListRequest from "../../api/raily/user/raily-officer/list/user-raily-officer-list.request";
import UserTaxiOfficerListRequest from "../../api/raily/user/taxi-officer/list/user-taxi-officer-list.request";
import userApiService from "../../api/raily/user/user-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import fileDownloadService from "../../utils/file-download/file-download.service";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import UserCargoOfficerList from "./cargo-officer/list/user-cargo-officer-list";
import UserCargoOfficerListError from "./cargo-officer/list/user-cargo-officer-list-error";
import UserCargoOfficerListParams from "./cargo-officer/list/user-cargo-officer-list-params";
import userCargoOfficerListParamsFactory from "./cargo-officer/list/user-cargo-officer-list-params.factory";
import userCargoOfficerListFactory from "./cargo-officer/list/user-cargo-officer-list.factory";
import UserCheckUserExistsError from "./check-user-exists/user-check-user-exists-error";
import UserCheckUserExistsParams from "./check-user-exists/user-check-user-exists-params";
import UserCheckUserExistsResult from "./check-user-exists/user-check-user-exists-result";
import UserDealerList from "./dealer/list/user-dealer-list";
import DealerListParams from "./dealer/list/user-dealer-list-params";
import userDealerListParamsFactory from "./dealer/list/user-dealer-list-params.factory";
import userDealerListFactory from "./dealer/list/user-dealer-list.factory";
import UserDeleteError from "./delete/user-delete-error";
import userDeleteErrorFactory from "./delete/user-delete-error.factory";
import UserDeleteParams from "./delete/user-delete-params";
import UserDispatcherEditForm from "./dispatcher/edit-form/user-dispatcher-edit-form";
import UserDispatcherEditFormError from "./dispatcher/edit-form/user-dispatcher-edit-form-error";
import UserDispatcherEditFormParams from "./dispatcher/edit-form/user-dispatcher-edit-form-params";
import userDispatcherEditFormParamsFactory from "./dispatcher/edit-form/user-dispatcher-edit-form-params.factory";
import userDispatcherEditFormFactory from "./dispatcher/edit-form/user-dispatcher-edit-form.factory";
import UserDispatcherList from "./dispatcher/list/user-dispatcher-list";
import UserDispatcherListError from "./dispatcher/list/user-dispatcher-list-error";
import UserDispatcherListParams from "./dispatcher/list/user-dispatcher-list-params";
import userDispatcherListParamsFactory from "./dispatcher/list/user-dispatcher-list-params.factory";
import userDispatcherListFactory from "./dispatcher/list/user-dispatcher-list.factory";
import UserDispatcherUpdateError from "./dispatcher/update/user-dispatcher-update-error";
import UserDispatcherUpdateParams from "./dispatcher/update/user-dispatcher-update-params";
import userDispatcherUpdateParamsFactory from "./dispatcher/update/user-dispatcher-update-params.factory";
import UserDriverDownloadError from "./driver/download/user-driver-download-error";
import UserDriverDownloadParams from "./driver/download/user-driver-download-params";
import userDriverDownloadParamsFactory from "./driver/download/user-driver-download-params.factory";
import UserDriverEditForm from "./driver/edit-form/user-driver-edit-form";
import UserDriverEditFormParams from "./driver/edit-form/user-driver-edit-form-params";
import userDriverEditFormParamsFactory from "./driver/edit-form/user-driver-edit-form-params.factory";
import userDriverEditFormFactory from "./driver/edit-form/user-driver-edit-form.factory";
import userDriverEditNotesParamsFactory from "./driver/edit-notes/user-driver-edit-notes-params.factory";
import UserDriverEditNotesError from "./driver/edit-notes/user-driver-edit-notes.error";
import UserDriverEditNotesParams from "./driver/edit-notes/user-driver-edit-notes.params";
import UserDriverEditError from "./driver/edit/user-driver-edit-error";
import UserDriverEditParams from "./driver/edit/user-driver-edit-params";
import userDriverEditParamsFactory from "./driver/edit/user-driver-edit-params.factory";
import UserDriverList from "./driver/list/user-driver-list";
import UserDriverListError from "./driver/list/user-driver-list-error";
import UserDriverListParams from "./driver/list/user-driver-list-params";
import userDriverListParamsFactory from "./driver/list/user-driver-list-params.factory";
import userDriverListFactory from "./driver/list/user-driver-list.factory";
import UserOperatorList from "./operator/list/user-operator-list";
import UserOperatorListError from "./operator/list/user-operator-list-error";
import UserOperatorListParams from "./operator/list/user-operator-list-params";
import userOperatorListParamsFactory from "./operator/list/user-operator-list-params.factory";
import userOperatorListFactory from "./operator/list/user-operator-list.factory";
import UserPassengerList from "./passenger/list/user-passenger-list";
import UserPassengerListError from "./passenger/list/user-passenger-list-error";
import UserPassengerListParams from "./passenger/list/user-passenger-list-params";
import userPassengerListParamsFactory from "./passenger/list/user-passenger-list-params.factory";
import userPassengerListFactory from "./passenger/list/user-passenger-list.factory";
import UserPasswordChangeError from "./password-change/user-password-change-error";
import UserPasswordChangeParams from "./password-change/user-password-change-params";
import userPasswordChangeParamsFactory from "./password-change/user-password-change-params.factory";
import UserRailyOfficerList from "./raily-officer/list/user-raily-officer-list";
import UserRailyOfficerListError from "./raily-officer/list/user-raily-officer-list-error";
import UserRailyOfficerListParams from "./raily-officer/list/user-raily-officer-list-params";
import userRailyOfficerListParamsFactory from "./raily-officer/list/user-raily-officer-list-params.factory";
import userRailyOfficerListFactory from "./raily-officer/list/user-raily-officer-list.factory";
import UserRestoreError from "./restore/user-restore-error";
import UserRestoreParams from "./restore/user-restore-params";
import UserTaxiOfficerList from "./taxi-officer/list/user-taxi-officer-list";
import UserTaxiOfficerListError from "./taxi-officer/list/user-taxi-officer-list-error";
import UserTaxiOfficerListParams from "./taxi-officer/list/user-taxi-officer-list-params";
import userTaxiOfficerListParamsFactory from "./taxi-officer/list/user-taxi-officer-list-params.factory";
import userTaxiOfficerListFactory from "./taxi-officer/list/user-taxi-officer-list.factory";

const checkUserExists = async (
  params: UserCheckUserExistsParams,
  abortSignal: AbortSignal,
): Promise<UserCheckUserExistsResult> => {
  try {
    const response = await userApiService().checkUserExists(
      { username: params.username },
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return {
      isExists: response.data,
    };
  } catch (_error) {
    const error = _error as HttpError | UserCheckUserExistsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const createUserDeleteErrorsNotAcceptableResponse = (
  response: UserDeleteNotAcceptableResponse,
  user: UserDeleteUserData,
): UserDeleteError => {
  switch (response.data.errorType) {
    case UserDeleteNotAcceptableResponseErrorType.DRIVER_HAS_CANDIDATURE:
      return userDeleteErrorFactory.createCandidatureCollisionError(user);
    case UserDeleteNotAcceptableResponseErrorType.DRIVER_HAS_ACTIVE_PLAN:
      return userDeleteErrorFactory.createActivePlanCollisionError(user);
    default:
      return dataLoadErrorFactory.createUnexpectedError();
  }
};

const deleteUser = async (
  params: UserDeleteParams,
  abortSignal: AbortSignal,
  user: UserDeleteUserData,
): Promise<void> => {
  try {
    const response = await userApiService().deleteUser(
      { userUuid: params.userUuid },
      abortSignal,
    );

    if (response.status === 406) {
      throw createUserDeleteErrorsNotAcceptableResponse(
        response as UserDeleteNotAcceptableResponse,
        user,
      );
    }

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | UserDeleteError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const restore = async (
  params: UserRestoreParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  try {
    const response = await userApiService().restore(
      { userUuid: params.userUuid },
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | UserRestoreError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const changePassword = async (
  params: UserPasswordChangeParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = userPasswordChangeParamsFactory.createRequest(params);

  try {
    const response = await userApiService().changePassword(
      request,
      abortSignal,
    );

    if (response.status !== 202) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | UserPasswordChangeError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getCargoOfficerList = async (
  params: UserCargoOfficerListParams,
  abortSignal: AbortSignal,
): Promise<UserCargoOfficerList> => {
  const request: UserCargoOfficerListRequest =
    userCargoOfficerListParamsFactory.create(params);

  try {
    const response = await userApiService().getCargoOfficerList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return userCargoOfficerListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | UserCargoOfficerListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDealerList = async (
  params: DealerListParams,
  abortSignal: AbortSignal,
): Promise<UserDealerList> => {
  const request: UserDealerListRequest =
    userDealerListParamsFactory.create(params);

  try {
    const response = await userApiService().getDealerList(request, abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const dealerList = userDealerListFactory.create(response);

    return dealerList;
  } catch (_error) {
    const error = _error as HttpError;

    throw handleErrorFactory.handleError(error);
  }
};

const getDispatcherList = async (
  params: UserDispatcherListParams,
  abortSignal: AbortSignal,
): Promise<UserDispatcherList> => {
  const request: UserDispatcherListRequest =
    userDispatcherListParamsFactory.create(params);

  try {
    const response = await userApiService().getDispatcherList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const dispatcherList = userDispatcherListFactory.create(response);

    return dispatcherList;
  } catch (_error) {
    const error = _error as HttpError | UserDispatcherListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateDispatcher = async (
  params: UserDispatcherUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: UserDispatcherUpdateRequest =
    userDispatcherUpdateParamsFactory.create(params);

  try {
    const response = await userApiService().updateDispatcher(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | UserDispatcherUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDispatcherEditForm = async (
  params: UserDispatcherEditFormParams,
  abortSignal: AbortSignal,
): Promise<UserDispatcherEditForm> => {
  const request: UserDispatcherEditFormRequest =
    userDispatcherEditFormParamsFactory.create(params);

  try {
    const response = await userApiService().getDispatcherEditForm(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return userDispatcherEditFormFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | UserDispatcherEditFormError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDriverList = async (
  params: UserDriverListParams,
  abortSignal: AbortSignal,
): Promise<UserDriverList> => {
  const request: UserDriverListRequest =
    userDriverListParamsFactory.create(params);

  try {
    const response = await userApiService().getDriverList(request, abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const driverList: UserDriverList = userDriverListFactory.create(response);

    return driverList;
  } catch (_error) {
    const error = _error as HttpError | UserDriverListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const downloadDriver = async (
  params: UserDriverDownloadParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: UserDriverDownloadRequest =
    userDriverDownloadParamsFactory.create(params);

  try {
    const response = await userApiService().downloadDriver(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    fileDownloadService.downloadFromBlob(
      response.data.data,
      response.data.filename,
    );
  } catch (_error) {
    const error = _error as HttpError | UserDriverDownloadError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const editDriver = async (
  params: UserDriverEditParams,
  abortSignal: AbortSignal,
  driverUuid: string,
): Promise<void> => {
  const request: User = userDriverEditParamsFactory.create(params);

  try {
    const response = await userApiService().editDriver(
      request,
      abortSignal,
      driverUuid,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | UserDriverEditError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const editDriverNotes = async (
  params: UserDriverEditNotesParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = userDriverEditNotesParamsFactory.create(params);

  try {
    const response = await userApiService().editDriverNotes(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | UserDriverEditNotesError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDriverEditForm = async (
  params: UserDriverEditFormParams,
  abortSignal: AbortSignal,
): Promise<UserDriverEditForm> => {
  const request: UserDriverEditFormRequest =
    userDriverEditFormParamsFactory.create(params);

  try {
    const response = await userApiService().getDriverEditForm(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const driverEditForm = userDriverEditFormFactory.create(response.data);

    return driverEditForm;
  } catch (_error) {
    const error = _error as HttpError | UserDriverListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOperatorList = async (
  params: UserOperatorListParams,
  abortSignal: AbortSignal,
): Promise<UserOperatorList> => {
  const request: UserOperatorListRequest =
    userOperatorListParamsFactory.create(params);

  try {
    const response = await userApiService().getOperatorList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return userOperatorListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | UserOperatorListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getPassengerList = async (
  params: UserPassengerListParams,
  abortSignal: AbortSignal,
): Promise<UserPassengerList> => {
  const request: UserPassengerListRequest =
    userPassengerListParamsFactory.create(params);

  try {
    const response = await userApiService().getPassengerList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const passengerList: UserPassengerList =
      userPassengerListFactory.create(response);

    return passengerList;
  } catch (_error) {
    const error = _error as HttpError | UserPassengerListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getRailyOfficerList = async (
  params: UserRailyOfficerListParams,
  abortSignal: AbortSignal,
): Promise<UserRailyOfficerList> => {
  const request: UserRailyOfficerListRequest =
    userRailyOfficerListParamsFactory.create(params);

  try {
    const response = await userApiService().getRailyOfficerList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return userRailyOfficerListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | UserRailyOfficerListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getTaxiOfficerList = async (
  params: UserTaxiOfficerListParams,
  abortSignal: AbortSignal,
): Promise<UserTaxiOfficerList> => {
  const request: UserTaxiOfficerListRequest =
    userTaxiOfficerListParamsFactory.create(params);

  try {
    const response = await userApiService().getTaxiOfficerList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return userTaxiOfficerListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | UserTaxiOfficerListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const userService = {
  checkUserExists,
  delete: deleteUser,
  restore,
  changePassword,
  getCargoOfficerList,
  getDealerList,
  getDispatcherList,
  updateDispatcher,
  getDispatcherEditForm,
  getDriverList,
  downloadDriver,
  editDriver,
  editDriverNotes,
  getDriverEditForm,
  getOperatorList,
  getPassengerList,
  getRailyOfficerList,
  getTaxiOfficerList,
};

export default userService;
